import * as hierarchyActions from "contexts/hierarchy/interface";
import { HierarchyContextProps } from "contexts/hierarchy/interface";
import { shouldRebuildDerivedSaveBlockers } from "./changesReplacements";
import { getDomainReplacementsSaveBlockers } from "./getDomainReplacementsSaveBlockers";
import { getSinglesSaveBlockers } from "./getSinglesSaveBlockers";
import { ISaveBlocker, ISaveBlockers } from "./interface";

/**
 * Derives the app-level save blockers after a hierarchy action. Blockers live in app settings
 * rather than the hierarchy slice, so they are composed here from the reduced hierarchy.
 *
 * @param saveBlockers - Current application save blockers.
 * @param hierarchyState - The hierarchy slice after the action was applied.
 * @param action - The hierarchy action that was applied.
 * @returns The updated save blockers.
 */
export const app_reduceHierarchySaveBlockers = (
  saveBlockers: ISaveBlockers,
  hierarchyState: HierarchyContextProps,
  action: hierarchyActions.IHierarchyAction,
): ISaveBlockers => {
  const updatedBlockers =
    action.operation === hierarchyActions.CLEAR_HIERARCHY ||
    action.operation === hierarchyActions.LOAD_HIERARCHY
      ? new Set<ISaveBlocker>()
      : !shouldRebuildDerivedSaveBlockers(action)
        ? saveBlockers
        : action.operation === hierarchyActions.SAVE_HIERARCHY_COMPLETED
          ? new Set<ISaveBlocker>()
          : new Set(
              Array.from(saveBlockers).filter(
                (blocker) => blocker.type !== "singles" && blocker.type !== "domainReplacements",
              ),
            );

  if (shouldRebuildDerivedSaveBlockers(action)) {
    getSinglesSaveBlockers(hierarchyState.hierarchy).forEach((blocker) =>
      updatedBlockers.add(blocker),
    );
    getDomainReplacementsSaveBlockers(hierarchyState.hierarchy).forEach((blocker) =>
      updatedBlockers.add(blocker),
    );
  }

  return updatedBlockers;
};
